import { useState, useEffect, useRef } from "react";
import Navbar from './Navbar';
import { db, collection, getDocs, query, where } from './Firebase';
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

export default function OrdersAndDetails() {
  const [contactNumber, setContactNumber] = useState("");
  const [orders, setOrders] = useState([]);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [error, setError] = useState("");
  const invoiceRef = useRef();

  const userName = localStorage.getItem("fullName") || "";
  const loggedInContact = localStorage.getItem("contactNumber") || "";

  useEffect(() => {
    if (loggedInContact) {
      setContactNumber(loggedInContact);
      fetchOrders(loggedInContact);
    }
  }, []);

  const fetchOrders = async (contact) => {
    setError("");
    if (!/^\d{10}$/.test(contact)) {
      setOrders([]);
      setError("Please enter a valid 10-digit contact number.");
      return;
    }
    try {
      const snapshot = await getDocs(query(
        collection(db, "Orders"),
        where("contact", "==", contact)
      ));
      const data = snapshot.docs.map(doc => doc.data()).reverse();
      setOrders(data);
      if (!data.length) setError("No orders found.");
    } catch {
      setError("Failed to fetch orders. Try again.");
    }
  };

  const downloadInvoice = () => {
    html2canvas(invoiceRef.current).then(canvas => {
      const pdf = new jsPDF();
      pdf.addImage(canvas.toDataURL("image/png"), 'PNG', 0, 0, 210, 297);
      pdf.save(`Invoice_${selectedOrder.orderId}.pdf`);
    });
  };

  const handleView = order => {
    setSelectedOrder(order);
    setTimeout(() => document.getElementById("order-details")?.scrollIntoView({ behavior: "smooth" }), 150);
  };

  return (
    <>
      <Navbar />
      <div className="container py-5">
        <h1 className="text-center text-gradient fw-bold mt-5 mb-4">🧾 My Orders</h1>
        {userName && <p className="text-center fs-5 mb-4">Hi, <strong className="text-primary">{userName}</strong>!</p>}

        {!loggedInContact && (
          <div className="row justify-content-center mb-4">
            <div className="col-md-6 input-group shadow-sm">
              <input className="form-control" placeholder="10-digit contact" value={contactNumber}
                onChange={e => setContactNumber(e.target.value)} maxLength={10} />
              <button className="btn btn-primary" onClick={() => fetchOrders(contactNumber)}>Search</button>
            </div>
            {error && <div className="text-danger text-center mt-2">{error}</div>}
          </div>
        )}

        {!selectedOrder ? (
          <div className="row g-4">
            {orders.map(order => (
              <div key={order.orderId} className="col-md-6 col-lg-4">
                <div className="card h-100 border-start border-4 border-primary shadow-sm animate-card">
                  <div className="card-body d-flex flex-column justify-content-between">
                    <div>
                      <h5>Order #{order.orderId}</h5>
                      <p className="mb-1">Status: <strong>{order.status}</strong></p>
                      <p className="mb-1">Total: ₹{order.totalAmount}</p>
                      <p className="mb-0">Payment: {order.paymentMethod === "gpay" ? "UPI" : "COD"}</p>
                    </div>
                    <button className="btn btn-outline-primary mt-3"
                      onClick={() => handleView(order)}>View Invoice</button>
                  </div>
                </div>
              </div>
            ))}
            {!orders.length && !error && <div className="col-12 text-center text-muted">No orders yet.</div>}
            {error && <div className="col-12 text-danger text-center">{error}</div>}
          </div>
        ) : (
          <div id="order-details" className="modal-content mx-auto my-4" style={{ maxWidth: "600px" }}>
            <div ref={invoiceRef} className="p-4 bg-white shadow-lg">
              <h2 className="text-center mb-3">🧁 KP Bakers</h2>
              <p><strong>Invoice #:</strong> {selectedOrder.orderId}</p>
              <p><strong>Date:</strong> {new Date(selectedOrder.createdAt).toLocaleString()}</p>
              <p><strong>Name:</strong> {selectedOrder.name}</p>
              <p><strong>Contact:</strong> {selectedOrder.contact}</p>
              <hr />
              <table className="table">
                <thead><tr>
                  <th>Item</th><th>Qty</th><th>Price</th><th>Total</th>
                </tr></thead>
                <tbody>
                  {selectedOrder.items.map((i, idx) => (
                    <tr key={idx}>
                      <td>{i.Name}</td><td>{i.quantity}</td>
                      <td>₹{i.Price}</td><td>₹{(i.Price * i.quantity).toFixed(2)}</td>
                    </tr>
                  ))}
                  <tr className="fw-bold">
                    <td colSpan="3">Delivery</td><td>₹40</td>
                  </tr>
                  <tr className="fw-bold">
                    <td colSpan="3">Total</td><td>₹{selectedOrder.totalAmount}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="text-center my-3">
              <button className="btn btn-success me-2" onClick={downloadInvoice}>Download Invoice</button>
              <button className="btn btn-outline-secondary" onClick={() => setSelectedOrder(null)}>Back</button>
            </div>
          </div>
        )}

        <style>{`
          .text-gradient { background: linear-gradient(90deg, #f39c12, #d35400); -webkit-background-clip: text; -webkit-text-fill-color: transparent; }
          .animate-card { transition: transform .3s, box-shadow .3s; }
          .animate-card:hover { transform: translateY(-8px); box-shadow: 0 8px 20px rgba(0,0,0,0.15); }
        `}</style>
      </div>
    </>
  );
}


// import React, { useState, useEffect } from "react";
// import { useParams } from "react-router-dom";
// import { db } from "./Firebase";
// import { doc, getDoc, updateDoc } from "firebase/firestore";

// export default function FeedbackPage() {
//   const { orderId } = useParams(); // Get the order ID from the URL
//   const [order, setOrder] = useState(null);
//   const [feedback, setFeedback] = useState("");

//   useEffect(() => {
//     const fetchOrder = async () => {
//       const orderRef = doc(db, "Billing", orderId);
//       const orderSnap = await getDoc(orderRef);

//       if (orderSnap.exists()) {
//         setOrder(orderSnap.data());
//       } else {
//         alert("Order not found.");
//       }
//     };

//     fetchOrder();
//   }, [orderId]);

//   const handleSubmitFeedback = async () => {
//     if (!feedback) {
//       alert("Please provide feedback.");
//       return;
//     }

//     // Update the feedback status and store the feedback in Firestore
//     const orderRef = doc(db, "Billing", orderId);
//     await updateDoc(orderRef, {
//       feedback: feedback,
//       feedbackStatus: "submitted",
//     });

//     alert("Thank you for your feedback!");
//   };

//   return (
//     <div>
//       <h1>Feedback for Order #{orderId}</h1>
//       {order ? (
//         <div>
//           <h3>Order Details:</h3>
//           <p>Name: {order.name}</p>
//           <p>Contact: {order.contact}</p>
//           <p>Items: {order.items.map(item => `${item.Name} (x${item.quantity})`).join(", ")}</p>

//           <h4>Your Feedback:</h4>
//           <textarea
//             value={feedback}
//             onChange={(e) => setFeedback(e.target.value)}
//             rows="4"
//             style={{ width: "100%" }}
//           />
//           <button onClick={handleSubmitFeedback} style={{ marginTop: "20px" }}>
//             Submit Feedback
//           </button>
//         </div>
//       ) : (
//         <p>Loading order details...</p>
//       )}
//     </div>
//   );
// }
